module.exports = __webpack_public_path__ + "static/media/vehicle.ea439486.svg";